var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "date-marker-container tooltipped tooltipped-s",
      attrs: { "aria-label": _vm.localeDate },
    },
    [
      _c("div", { staticClass: "date-marker" }, [
        _c("span", {
          staticClass: "date-marker-text",
          attrs: { "aria-label": _vm.friendlyDate() },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }